export default __webpack_public_path__ + "static/media/IMG_6333.008cf970.JPG";